import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "",
  description:
    "In this example, we will see how the radiosity method works. At first, you can click “Next”, then energy is shot by the sound source and collected by the patches on the wall. In white, you can see the energy of each path, either the unshot or the shot energy, you can change the view by clicking on “Change Energy”. Click now “Next” to see how the energy is shot from the patches. Click it several times so that the energy is spreaded in the room. Then you can click “Finalize”, and then the energy from the patches will be collected at the receiver (red) and displayed in a histogram. Note that you can shift the source and receiver positions by drag-n-drop.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_STATIC_URL}/0310/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
